export default __webpack_public_path__ + "static/media/02Laurielle.ef272ed6.jpg";